import { render, staticRenderFns } from "./PriceForm.vue?vue&type=template&id=02829393&"
import script from "./PriceForm.vue?vue&type=script&lang=js&"
export * from "./PriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports